import { bookDemoActionTypes as ACTION } from '../actionTypes';

const initialState = {
  loading: false,
  error: '',
  bookDemo: {
    message: '',
  },
};

const bookDemoReducer = (state = initialState, action) => {
  switch (action.type) {
    case ACTION.BOOKDEMO_REQUEST:
      return {
        ...state,
        loading: true,
        error: '',
        bookDemo: {
          message: '',
        },
      };
    case ACTION.BOOKDEMO_SUCCESS:
      let { message } = action.payload;
      return {
        ...state,
        loading: false,
        error: '',
        bookDemo: {
          message: message,
        },
      };
    case ACTION.BOOKDEMO_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        bookDemo: {
          message: '',
        },
      };
    case ACTION.REMOVE_BOOKDEMO_POPUP:
      return {
        ...state,
        loading: false,
        bookDemo: {
          message: '',
        },
        error: '',
      };
    default:
      return state;
  }
};
export default bookDemoReducer;
